import { render, staticRenderFns } from "./FinanceIncome.vue?vue&type=template&id=4f9885ec&scoped=true&"
import script from "./FinanceIncome.vue?vue&type=script&lang=js&"
export * from "./FinanceIncome.vue?vue&type=script&lang=js&"
import style0 from "./FinanceIncome.vue?vue&type=style&index=0&id=4f9885ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9885ec",
  null
  
)

export default component.exports